import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../constants/common'
import { CustomSelect } from '../../../CustomSelect'
import { FieldStackedLabel } from '../../../Field'
import { FormFieldSelect } from '../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../Formik'
import { getRequestStatuses } from '../RequestEditStatusModal.api'
import { REQUEST_EDIT_STATUS_FIELD_NAME } from '../RequestEditStatusModal.constants'
import { RequestEditStatusModalSelectButton } from '../RequestEditStatusModalSelectButton'

import {
  getRequestEditStatusModalStatusFieldLabel,
  getRequestEditStatusModalStatusFieldValue,
} from './RequestEditStatusModalStatusField.utils'

function RequestEditStatusModalStatusField() {
  const { t } = useTranslation()

  const [options, setOptions] = useState(EMPTY_LIST)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getRequestStatuses()
      .then(({ data }) => {
        setOptions(data.results.objects)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <FormikField
      showLabel
      Button={RequestEditStatusModalSelectButton}
      Component={FormFieldSelect}
      Field={FieldStackedLabel}
      Select={CustomSelect}
      buttonType='select'
      fieldComponentProps={{
        isLoading: loading,
        label: t('Request.StatusLabelKey'),
        required: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      getLabel={getRequestEditStatusModalStatusFieldLabel}
      getValue={getRequestEditStatusModalStatusFieldValue}
      listType='status'
      name={REQUEST_EDIT_STATUS_FIELD_NAME}
      options={options}
      placeholder={t('Request.SelectStatusLabelKey')}
    />
  )
}

export default RequestEditStatusModalStatusField
